<template>
  <el-dialog :title="$t('addShopTypeMenu.add')" :visible.sync="dialogVisible" width="70%">
    <el-form ref="form" :model="addShopTypeMenuInfo" label-width="120px">
      <el-form-item :label="$t('addShopTypeMenu.menuName')" prop="hktName"
        :rules="[{ required: true, message: $t('addShopTypeMenu.menuNameRequired') }]">
        <el-input v-model="addShopTypeMenuInfo.hktName" :placeholder="$t('addShopTypeMenu.inputMenuName')" />
      </el-form-item>
      <el-form-item :label="$t('addShopTypeMenu.logo')" prop="hktIcon"
        :rules="[{ required: true, message: $t('addShopTypeMenu.logoRequired') }]">
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('addShopTypeMenu.menuDesc')" prop="hktDesc">
        <el-input v-model="addShopTypeMenuInfo.hktDesc" :placeholder="$t('addShopTypeMenu.inputMenuDesc')" />
      </el-form-item>
      <el-form-item :label="$t('addShopTypeMenu.label')" prop="label">
        <el-input v-model="addShopTypeMenuInfo.label" :placeholder="$t('addShopTypeMenu.inputLabel')" />
      </el-form-item>
      <el-form-item :label="$t('addShopTypeMenu.shopType')" prop="typeId"
        :rules="[{ required: true, message: $t('addShopTypeMenu.shopTypeRequired') }]">
        <el-select v-model="addShopTypeMenuInfo.typeId" :placeholder="$t('addShopTypeMenu.selectShopType')"
          style="width:100%">
          <el-option :label="$t('addShopTypeMenu.selectShopType')" value="" />
          <el-option v-for="shopType in addShopTypeMenuInfo.shopTypes" :key="shopType.shopTypeId || shopType.typeId" 
            :label="shopType.typeName" :value="shopType.shopTypeId || shopType.typeId" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addShopTypeMenu.sort')" prop="seq"
        :rules="[{ required: true, message: $t('addShopTypeMenu.sortRequired') }]">
        <el-input v-model="addShopTypeMenuInfo.seq" :placeholder="$t('addShopTypeMenu.inputSort')" />
      </el-form-item>
      <el-form-item :label="$t('addShopTypeMenu.isShow')" prop="isShow"
        :rules="[{ required: true, message: $t('addShopTypeMenu.showStatusRequired') }]">
        <el-select v-model="addShopTypeMenuInfo.isShow" :placeholder="$t('addShopTypeMenu.selectShowStatus')" style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveShopTypeMenuInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveProductMenu } from '@/api/admin/shopProductType/shopProductTypeApi'
import { queryShopType } from '@/api/admin/shopTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'AddShopTypeMenu',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      addShopTypeMenuInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '5',
        isShow: '',
        typeCd: '2002',
        typeId: '',
        shopTypes: []
      }
    }
  },
  methods: {
    open(data = {}) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.addShopTypeMenuInfo = {
          ...this.addShopTypeMenuInfo,
          ...data
        }
        if (data.hktIcon) {
          this.$refs.uploadImage.setImages([data.hktIcon])
        } else {
          this.$refs.uploadImage.clearImages()
        }
        this.loadShopTypes()
      })
    },
    async loadShopTypes() {
      try {
        const res = await queryShopType({
          page: 1,
          row: 100,
          isShow: 'Y'
        })
        this.addShopTypeMenuInfo.shopTypes = res.data || []
      } catch (error) {
        console.error(error)
      }
    },
    handleUploadImage(photos) {
      this.addShopTypeMenuInfo.hktIcon = photos && photos.length > 0 ? photos[0] : ''
    },
    async saveShopTypeMenuInfo() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        if (!this.addShopTypeMenuInfo.typeId) {
          this.$message.error(this.$t('addShopTypeMenu.shopTypeRequired'))
          return
        }

        // 根据选择的店铺类型动态设置 URL
        this.addShopTypeMenuInfo.url = `/pages/index/category?typeId=${this.addShopTypeMenuInfo.typeId}`
        this.addShopTypeMenuInfo.skipType = '5'

        await saveProductMenu(this.addShopTypeMenuInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

